<ui-dialog
    formDialog
    [open]="isRoleDialogOpen"
    [isCloseable]="true"
    header="settings.roles.addRoleDialogHeader"
    (primaryButtonPressed)="onCreate(roleForm.role, roleForm)"
    (closing)="closeRoleDialog()"
    [form]="roleForm.form"
    size="small"
>
    <app-settings-role-create-form #roleForm></app-settings-role-create-form>
</ui-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'settings.roles.header' | translate }}" [menuService]="settingsMenuService">
        <div class="buttons">
            <ui-button type="primary" (click)="roleForm.showSetup = true; openRoleDialog()">
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'settings.roles.createCustomRoleButton' | translate }}
            </ui-button>
        </div>
    </app-header>

    <app-table
        class="table"
        [table]="defaultRolesIndexTable"
        [useStickyHeader]="false"
        [showSearch]="false"
        [noWhiteSpace]="true"
        title="{{ 'settings.roles.defaultRolesTableTitle' | translate }}"
    >
        <div class="empty">
            <h2 class="ui centered header">{{ 'settings.roles.noDefaultRolesMessage' | translate }}</h2>
        </div>
    </app-table>

    <app-table
        *ngIf="!customRolesIndexTable.isEmpty; else customRolesEmptyState"
        class="table"
        [table]="customRolesIndexTable"
        [useStickyHeader]="false"
        [showSearch]="false"
        title="{{ 'settings.roles.customRolesTableTitle' | translate }}"
    >
        <app-empty-state label="settings.roles.noCustomRolesMessage"></app-empty-state>
    </app-table>
    <ng-template #customRolesEmptyState>
        <ui-card class="empty" [withSpacing]="false">
            <div>
                <img src="/assets/illustrations/Laptop-Fail.png" />
                <h2 class="centered">{{ 'settings.roles.emptyStateTitle' | translate }}</h2>
                <p>{{ 'settings.roles.emptyStateLine' | translate }}</p>

                <div class="emptyStateButtons flex align-items-center">
                    <ui-button type="outline" [externalLink]="true" [url]="learnMoreUrl" [openInNewTab]="true">
                        <span>{{ 'settings.roles.learnMore' | translate }}</span>
                    </ui-button>
                    <ui-button type="primary" (click)="roleForm.showSetup = true; openRoleDialog()">
                        <mat-icon svgIcon="plus"></mat-icon>
                        {{ 'settings.roles.createCustomRoleButton' | translate }}
                    </ui-button>
                </div>
            </div>
        </ui-card>
    </ng-template>
</div>
